<template>
    <div>
        <div v-if="audio" class="has-text-centered">
            <p class="is-centered">
                {{ audio.name }}
            </p>
            <div class="level">
                <audio :src="audio.url" controls class="level-item" />
                <a class="delete is-medium level-item" @click="removeFile" />
            </div>
        </div>
        <div class="file is-centered">
            <label class="file-label">
                <input
                    ref="fileInput"
                    class="file-input"
                    type="file"
                    accept="audio/*"
                    @change="handleFile"
                />
                <span class="file-cta">
                    <span v-if="uploading" class="file-icon">
                        <i class="fas fa-circle-notch fa-pulse" />
                    </span>
                    <span v-if="uploading" class="file-label"
                        >{{ progress }} %</span
                    >
                    <span
                        v-else
                        v-t="'creation.select_file'"
                        class="file-label"
                    />
                </span>
            </label>
        </div>
    </div>
</template>

<script>
import { upload } from '@/services/API';
export default {
    name: 'InputAudio',
    model: {
        prop: 'audio',
    },
    props: { audio: { type: Array, default: undefined } },
    data() {
        return {
            uploading: false,
            progress: 0,
        };
    },
    methods: {
        async handleFile(ev) {
            this.uploading = true;
            let config = {
                onUploadProgress: (progressEvent) => {
                    let percentCompleted = Math.floor(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    this.progress = percentCompleted;
                },
            };
            this.$emit('uploading');
            let response = await upload(`audio`, ev.target.files, config)
                .catch(() => {
                    return this.$emit('error');
                })
                .finally(() => {
                    return (this.uploading = false);
                });
            this.$emit('input', response.data.audio[0]);
        },
        removeFile() {
            this.$emit('input', null);
            this.resetFile();
        },
        resetFile() {
            const input = this.$refs.fileInput;
            input.value = '';
        },
    },
};
</script>

<style></style>
